import React, { FunctionComponent } from 'react'
import { Box, Menu, MenuButton, MenuList, MenuItem, Text, HStack, Icon } from '@chakra-ui/react'
import { UserCircleIcon } from '@heroicons/react/24/outline'
import { auth } from 'lib/firebase'
import { useAuthContext } from 'context/auth'
import { LINEAGE_DATA } from '../../lib/lineage'

const ProfileMenu: FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  const { firebaseUser } = useAuthContext()
  const displayName = firebaseUser?.displayName || 'Anonymous'
  const personData = LINEAGE_DATA[displayName as keyof typeof LINEAGE_DATA]

  return (
    <Box px={8}>
      {firebaseUser && (
        <div>
          <Menu>
            <MenuButton>
              <HStack spacing={2}>
                <Icon as={UserCircleIcon} boxSize={5} color='gray.600' />
                <Text>
                  {displayName}
                  {personData && ` (${personData.desc})`}
                </Text>
              </HStack>
            </MenuButton>
            <MenuList>
              <MenuItem
                onClick={async () => {
                  await auth.signOut()
                  window.location.reload()
                }}
              >
                Logout
              </MenuItem>
            </MenuList>
          </Menu>
        </div>
      )}
    </Box>
  )
}

export default ProfileMenu
